<div class="cardtable h-fit" [ngClass]="{'compact': size === 'small'}" *ngIf="datavalues && datavalues.length > 0; else noData">
  <div class="cardtable-body">
    <p-table
      #dt
      [value]="datavalues"
      sortMode="single"
      [scrollable]="true"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      responsiveLayout="stack" breakpoint="680px"
      [globalFilterFields]="_globalFilters"
    >
      <ng-template pTemplate="header">
          <tr>
              <th *ngFor="let column of datacolumns" [pSortableColumn]="column.field" class="truncate">
                {{column.value}} <p-sortIcon [field]="column.field"></p-sortIcon>
                <p-columnFilter *ngIf="column.filterable !== undefined && column.filterable"
                  type="column.filterType"
                  [field]="column.field" display="menu"></p-columnFilter>
              </th>
              <th *ngIf="dataactions.length > 0"></th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-value>
          <tr>
            <td *ngFor="let col of datacolumns" class="p-1 px-3">
              <p class="visible md:md:hidden font-bold">{{value[col.value!]}}</p>
              <ng-container>
                <span class=" ... sm:text-xs lg:text-sm" [innerHTML]="col?.isComplex ?  getComplexColumn(col.field, value ) : (col?.fn ? col.fn(value[col.field]) : value[col.field])" ></span>
              </ng-container>
            </td>
            <td *ngIf="dataactions.length > 0" class="p-1">
              <ng-container *ngFor="let action of dataactions">
                <button type="button" *ngIf="action.condition === undefined || action.condition(value)"
                [class]="showActionLabels ? 'mx-1 border-0 bg-[#429DCF] text-white px-3 py-1 text-sm rounded-lg text-center hover:bg-cyan-700 transition-colors' : 'border-0 bg-black text-white px-1 py-1 text-sm rounded-lg text-center ' + action.colorClass"
                (click)="openConsult(value)">{{showActionLabels ? action.label : ''}}

                <i class="pi pi-eye"></i>
                </button>
              </ng-container>
            </td>
          </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<ng-template #noData>
  <div #noData class="px-2">
          <div class="px-16 flex justify-center items-center w-full bg-slate-200 border border-dashed border-slate-500 rounded-xl hover:cursor-pointer p-40">
            <h1 class="text-center text-2xl text-slate-500">
              Aún no tienes datos para mostrar<br>
            </h1>
          </div>
  </div>
</ng-template>

<div *ngIf="consultBooking" class="w-[800px] border-2 border-[#27368A] bg-white left-[10%] top-[20%] overflow-hidden absolute z-10 px-4 pb-3" >
  <div class="flex flex-col m-0 pt-3 ">
    <div class="flex justify-end items-start ">
      <button (click)="closeConsultBooking()" class="button-close h-6 w-6 flex items-center justify-center bg-transparent rounded-full hover:bg-[#cdd6dabd]">
      <svg class="h-5 w-5 text-[#6c757d]" width="24" height="24" viewBox="0 0 24 24" stroke-width="1"
        stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" />
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
      </button>
    </div>
  </div>

  <div  class="flex flex-row mb-2 gap-1">
    <p class="text-[#27368A] font-extrabold text-xl ">RESERVA:</p>
    <p class="text-red-600 font-bold text-xl">#{{ bookingData.booking.reference }}</p>
    <p class="text-gray-400 text-base flex items-end ">(oficina {{ bookingData.booking.office?.name }})</p>
  </div>

  <div class="mb-4">
    <p class="text-[#27368A] font-extrabold text-lg">Fecha y hora reservadas</p>
    <p class="text-[#8A8A8A] font-bold text-base">{{ formatDate(bookingData.date) }} - {{ bookingData.hour }}</p>
  </div>

  <div class="grid grid-cols-2 mb-3">

    <div>
      <div class="mb-4">
        <p class="text-[#27368A] font-extrabold text-lg">Datos Reserva</p>
      <div class="flex flex-row gap-1">
        <p class="text-[#8A8A8A] font-bold text-base">Servicio: </p>
        <p class="text-[#8A8A8A] text-base"> {{ bookingData.service_profile.name }}</p>
      </div>
      <div class="flex flex-row gap-1">
        <p class="text-[#8A8A8A] font-bold text-base">Personas:</p>
        <p class="text-[#8A8A8A] text-base">{{ bookingData.units }}</p>
      </div>
    </div>

    <div class="mb-4">
      <p class="text-[#27368A] font-extrabold text-lg">Datos Titular</p>
      <div class="flex flex-row gap-1">
        <p class="text-[#8A8A8A] font-bold text-base">Nombre completo:</p>
        <p class="text-[#8A8A8A] text-base">{{ bookingData.booking.customer.name }}</p>
      </div>
      <div class="flex flex-row gap-1">
        <p class="text-[#8A8A8A] font-bold text-base">DNI:</p>
        <p class="text-[#8A8A8A] text-base">{{ bookingData.booking.customer.cif || bookingData.booking.customer.vat }}</p>
      </div>
      <div class="flex flex-row gap-1">
        <p class="text-[#8A8A8A] font-bold text-base">Teléfono:</p>
        <p class="text-[#8A8A8A] text-base">{{ bookingData.booking.customer.phone }}</p>
      </div>
      <div class="flex flex-row gap-1">
        <p class="text-[#8A8A8A] font-bold text-base">Email:</p>
        <p class="text-[#8A8A8A] text-base">{{ bookingData.booking.customer.email }}</p>
      </div>
    </div>
  </div>

  <div>
    <div class="mb-14">
      <div class="grid grid-cols-2 align-middle items-center gap-1">
        <p class="text-[#27368A] font-extrabold text-lg">Importe total: </p>
        <p class="text-[#8A8A8A] font-bold text-base">{{ bookingData.total_amount }} €</p>
      </div>
      <!-- <div class="grid grid-cols-2 mb-4">
        <p class="text-[#27368A] font-extrabold text-lg">Estado</p>
        <p class="text-center text-white font-semibold text-base mt-1 rounded-md {{bookingData.booking.status.color}} {{bookingData.booking.status.text_color}}" >{{ bookingData.booking.status.status }}</p>
      </div> -->
    </div>

    <div class="mb-4">
      <p class="text-[#27368A] font-extrabold text-lg">Datos de facturación</p>
      <div class="flex flex-row gap-1">
        <p class="text-[#8A8A8A] font-bold text-base">Razón social:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingData.booking.customer.name }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">DNI/CIF:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingData.booking.customer.cif || bookingData.booking.customer.vat }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Teléfono:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingData.booking.customer.phone }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Email:</p>
          <p class="text-[#8A8A8A] text-base">{{ bookingData.booking.customer.email }}</p>
        </div>
        <div class="flex flex-row gap-1">
          <p class="text-[#8A8A8A] font-bold text-base">Dirección:</p>
          <p class="text-[#8A8A8A] text-base">
            {{ bookingData.booking.billing_address.street_name }}
            {{ bookingData.booking.billing_address?.street_number }}
            {{ bookingData.booking.billing_address?.floor }}
            {{ bookingData.booking.billing_address?.description }}
            {{ bookingData.booking.billing_address?.city }}-
            {{ bookingData.booking.billing_address?.province }}
            {{ bookingData.booking.billing_address?.country }}
            {{ bookingData.booking.billing_address?.postal_code }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
